( function () {
	'use strict';

	angular.module( 'app', [
		/*
		 * Everybody has access to these.
		 * We could place these under every feature area,
		 * but this is easier to maintain.
		 */
		'app.core',
		'app.components',
		'exceptionOverride',
		/*
		 * Feature areas
		 */
		'app.login',
		'app.observations',
		'app.templates',
		'app.report',
		'app.layout',
		'app.schedules',
		'app.forgot-password',
		'app.dashboard',

		/*
		 * Helpers
		 */
		'ui.bootstrap',
		'angularMoment',
		'frapontillo.bootstrap-switch',
		'ngTagsInput',
		'ngDragDrop',
		'mwl.calendar',
		'ui.bootstrap',
		'ui.validate',
		'monospaced.elastic',
		'duScroll',
		'ui',
		'ui.sortable',
		'angularViewportWatch',
		'ui.grid',
		'ui.grid.autoResize',
		'ui.grid.selection',
		'ui.grid.exporter',
		'ui.grid.resizeColumns',
		'ui.grid.grouping',
		'ui.grid.expandable',
		'as.sortable',
		'angular-redactor',
		'nvd3',
		'ngFileUpload',
		'angularLoad',
		/*
		 * Components
		 */
		'ngMarionetteCore',
		'feedback-template',
		'feedback',
		'report-component',
		'report-template'
	] );
} )( );
